// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-3862a820] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
#app-settings[data-v-3862a820] {
  margin-top: auto;
  padding: 3px;
}
#app-settings__header[data-v-3862a820] {
  box-sizing: border-box;
  margin: 0 3px 3px 3px;
}
#app-settings__header .settings-button[data-v-3862a820] {
  display: flex;
  flex: 1 1 0;
  height: var(--default-clickable-area);
  width: 100%;
  padding: 0;
  margin: 0;
  background-color: transparent;
  box-shadow: none;
  border: 0;
  border-radius: var(--body-container-radius);
  text-align: start;
  font-weight: normal;
  font-size: 100%;
  color: var(--color-main-text);
  padding-inline-end: 14px;
  line-height: var(--default-clickable-area);
}
#app-settings__header .settings-button[data-v-3862a820]:hover, #app-settings__header .settings-button[data-v-3862a820]:focus {
  background-color: var(--color-background-hover);
}
#app-settings__header .settings-button__label[data-v-3862a820] {
  overflow: hidden;
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
}
#app-settings__content[data-v-3862a820] {
  display: block;
  padding: 10px;
  /* prevent scrolled contents from stopping too early */
  margin-bottom: -3px;
  /* restrict height of settings and make scrollable */
  max-height: 300px;
  overflow-y: auto;
  box-sizing: border-box;
}
.slide-up-leave-active[data-v-3862a820],
.slide-up-enter-active[data-v-3862a820] {
  transition-duration: var(--animation-slow);
  transition-property: max-height, padding;
  overflow-y: hidden !important;
}
.slide-up-enter[data-v-3862a820],
.slide-up-leave-to[data-v-3862a820] {
  max-height: 0 !important;
  padding: 0 10px !important;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcAppNavigationSettings-_Qi3rUlw.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,WAAW;EACX,qCAAqC;EACrC,WAAW;EACX,UAAU;EACV,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,SAAS;EACT,2CAA2C;EAC3C,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,wBAAwB;EACxB,0CAA0C;AAC5C;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,aAAa;EACb,sDAAsD;EACtD,mBAAmB;EACnB,oDAAoD;EACpD,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;;EAEE,0CAA0C;EAC1C,wCAAwC;EACxC,6BAA6B;AAC/B;AACA;;EAEE,wBAAwB;EACxB,0BAA0B;AAC5B","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-3862a820] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n#app-settings[data-v-3862a820] {\n  margin-top: auto;\n  padding: 3px;\n}\n#app-settings__header[data-v-3862a820] {\n  box-sizing: border-box;\n  margin: 0 3px 3px 3px;\n}\n#app-settings__header .settings-button[data-v-3862a820] {\n  display: flex;\n  flex: 1 1 0;\n  height: var(--default-clickable-area);\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  background-color: transparent;\n  box-shadow: none;\n  border: 0;\n  border-radius: var(--body-container-radius);\n  text-align: start;\n  font-weight: normal;\n  font-size: 100%;\n  color: var(--color-main-text);\n  padding-inline-end: 14px;\n  line-height: var(--default-clickable-area);\n}\n#app-settings__header .settings-button[data-v-3862a820]:hover, #app-settings__header .settings-button[data-v-3862a820]:focus {\n  background-color: var(--color-background-hover);\n}\n#app-settings__header .settings-button__label[data-v-3862a820] {\n  overflow: hidden;\n  max-width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n#app-settings__content[data-v-3862a820] {\n  display: block;\n  padding: 10px;\n  /* prevent scrolled contents from stopping too early */\n  margin-bottom: -3px;\n  /* restrict height of settings and make scrollable */\n  max-height: 300px;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n.slide-up-leave-active[data-v-3862a820],\n.slide-up-enter-active[data-v-3862a820] {\n  transition-duration: var(--animation-slow);\n  transition-property: max-height, padding;\n  overflow-y: hidden !important;\n}\n.slide-up-enter[data-v-3862a820],\n.slide-up-leave-to[data-v-3862a820] {\n  max-height: 0 !important;\n  padding: 0 10px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
